/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dropdownItemOfintSchema } from './dropdownItemOfintSchema.ts';
import { z } from 'zod';

export const getOfficeSchema = z.object({
  id: z.coerce.number().int().optional(),
  name: z.coerce.string(),
  client: z.lazy(() => dropdownItemOfintSchema),
  isVisible: z.boolean(),
});
